import { FormattedMessage } from 'react-intl';
import styled, { CSSProperties, css } from 'styled-components';

import { Horizontal } from 'atoms/layout/flex';
import { LabelS } from 'atoms/typography';
import { range } from 'lib/arrays';
import { Color } from 'style/types';

const Root = styled(Horizontal)`
  --active-color: var(--c-neutral-100);
  --color: var(--c-neutral-600);
  --nb-items: 3;

  flex: 1;
  & > :first-child {
    flex: 1;
  }
`;

const ProgressWrapper = styled.div<{ filled: boolean }>`
  width: calc(100% / var(--nb-items));
  height: var(--unit);
  transform: skewX(-30deg);

  background-color: var(--color);
  ${({ filled }) =>
    filled &&
    css`
      background-color: var(--active-color);
    `}
`;

type Props = {
  progress: number | null;
  target: number | null;
  color?: Color;
  activeColor?: Color;
  className?: string;
};
export const Progress = ({
  progress,
  target,
  color,
  activeColor,
  className,
}: Props) => {
  if (!target) {
    return null;
  }

  return (
    <Root
      className={className}
      gap={2}
      style={
        {
          '--color': color,
          '--active-color': activeColor,
          '--nb-items': target,
        } as CSSProperties
      }
    >
      <Horizontal gap={0.5}>
        {range(target).map(x => (
          <ProgressWrapper key={x} filled={x < (progress || 0)} />
        ))}
      </Horizontal>
      <LabelS color={activeColor} bold>
        <FormattedMessage
          id="ManagerProgressionMissionContentTile.progression"
          defaultMessage="{progress}/{target}"
          values={{ progress, target }}
        />
      </LabelS>
    </Root>
  );
};
